






























































































































































































import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import suiviConsoMixin from './etatStockMixin'
import { Chart, ChartConfiguration, ChartData, ChartOptions, registerables } from 'chart.js'
Chart.register(...registerables)
import ChartDataLabels from 'chartjs-plugin-datalabels'
import _ from 'lodash'
import Openable from '@/global/viewmodels/openable'
import { EtatStockOutput_RotationStockFamille, EtatStockOutput_RotationStockProduit } from './models/EtatStockOutput'
import { RoleEnum } from '@/domain/role'
Chart.register(ChartDataLabels)

const colors = ['#7fdbff', '#0074d9', '#01ff70', '#001f3f', '#39cccc', '#3d9970', '#2ecc40', '#ff4136', '#85144b', '#ff851b', '#b10dc9', '#ffdc00', '#f012be', '#aaaaaa', '#111111', '#dddddd']

export default mixins(suiviConsoMixin, mobileTypeMixin).extend({
    components: {
        BAlert: () => import('@/layout/components/BiobankAlert.vue')
    },
    data() {
        return { alert: new Openable() }
    },
    computed: {
        config(): ChartConfiguration {
            const that = this
            const baseOptions: ChartOptions = {
                responsive: true,
                plugins: {
                    legend: {
                        fullSize: true,
                        align: 'start',

                        position: this.isMobileDevice() ? 'top' : 'left',
                        onClick: function(event, elem) {
                            if (!that.codeFamilleSelectionne) {
                                // @ts-ignore
                                const data = that.etatStock?.codeFamille[elem.index]
                                if (data) {
                                    that.codeFamilleSelectionne = data
                                    that.$nextTick(() => that.generateChart())
                                }
                            }
                        }
                    },
                    datalabels: {
                        backgroundColor: function(context: any) {
                            return context.dataset.backgroundColor
                        },
                        borderColor: 'white',
                        borderRadius: 25,
                        borderWidth: 2,
                        color: 'white',
                        display: function() {
                            return true
                        },
                        font: {
                            weight: 'bold'
                        },
                        padding: 6,
                        formatter: Math.round
                    }
                },
                // Core options
                layout: {
                    padding: 16
                },
                animation: {
                    duration: 500
                }
            }
            if (!this.etatStock)
                return {
                    type: 'doughnut' as 'doughnut',
                    data: {
                        labels: [],
                        datasets: []
                    },
                    options: baseOptions
                }
            if (!this.codeFamilleSelectionne) {
                const labels = this.etatStock.codeFamille
                    .map(code => `${this.etatStock?.statsGlobalesFamilles[code].libelleFamille} (${this.etatStock?.statsGlobalesFamilles[code].nombreArticle})`)
                    .sort((a, b) => a.localeCompare(b))
                    .filter(function(x): x is string {
                        return x !== undefined
                    })
                const data = this.etatStock.codeFamille
                    .sort((a, b) => (this.etatStock?.statsGlobalesFamilles[a].libelleFamille ?? '').localeCompare(this.etatStock?.statsGlobalesFamilles[b].libelleFamille ?? ''))
                    .map(code => this.etatStock?.statsGlobalesFamilles[code].nombreArticle)
                    .filter(function(x): x is number {
                        return x !== undefined
                    })

                const datas: ChartData = {
                    labels: labels,
                    datasets: [
                        {
                            label: `Répartition des famille de produits achetés`,
                            data: data,
                            backgroundColor: data.map((x, index) => colors[index]),
                            datalabels: {
                                display: false
                            }
                        }
                    ]
                }

                // prettier-ignore
                const that = this;
                const options = Object.assign(baseOptions, {
                    onClick: function() {
                        if (!that.chart) return

                        const activeEl = that.chart.getActiveElements()
                        if (activeEl.length == 0) return null

                        if (!that.chart.data.labels) return

                        const data = that.etatStock?.codeFamille[activeEl[0].index]
                        if (data) {
                            that.codeFamilleSelectionne = data
                            that.$nextTick(() => that.generateChart())
                        }
                    }
                })

                return {
                    type: 'doughnut' as 'doughnut',
                    data: datas,
                    options: options
                }
            } else {
                const labels = Object.keys(this.etatStock.statsGlobalesFamilles[this.codeFamilleSelectionne].nombreArticlePourProduit)
                    .filter(function(x): x is string {
                        return x !== undefined
                    })
                    .sort((a, b) => a.localeCompare(b))
                const data = labels
                    .map(name => this.etatStock?.statsGlobalesFamilles[this.codeFamilleSelectionne].nombreArticlePourProduit[name].nombre)
                    .filter(function(x): x is number {
                        return x !== undefined
                    })

                const datas: ChartData = {
                    labels: labels,
                    datasets: [
                        {
                            label: `Répartition des produits achetés de la famille "${this.etatStock.statsGlobalesFamilles[this.codeFamilleSelectionne].libelleFamille}}"`,
                            data: data,
                            backgroundColor: data.map((x, index) => colors[index]),
                            datalabels: {
                                display: false
                            }
                        }
                    ]
                }

                return {
                    type: 'doughnut' as 'doughnut',
                    data: datas,
                    options: baseOptions
                }
            }
        },
        listeFamilles() {
            if (this.etatStock) {
                return _.chain(this.etatStock.codeFamille)
                    .map(code => ({
                        label: this.etatStock?.statsGlobalesFamilles[code].libelleFamille,
                        code: code,
                        data: this.etatStock?.statsGlobalesFamilles[code].nombreArticle
                    }))
                    .filter(function(x) {
                        return x.data !== undefined
                    })
                    .orderBy(a => a.label)
                    .value()
            }
        },
        listeProduitsCodeFamille: function() {
            if (this.etatStock && this.codeFamilleSelectionne) {
                const labels = Object.keys(this.etatStock.statsGlobalesFamilles[this.codeFamilleSelectionne].nombreArticlePourProduit).filter(function(x): x is string {
                    return x !== undefined
                })
                return _.chain(labels)
                    .map(name => {
                        return {
                            data: this.etatStock?.statsGlobalesFamilles[this.codeFamilleSelectionne].nombreArticlePourProduit[name].nombre,
                            label: name,
                            infoRotation: this.etatStock?.statsGlobalesFamilles[this.codeFamilleSelectionne].nombreArticlePourProduit[name].infoRotation
                        }
                    })
                    .filter(function(x) {
                        return x.data !== undefined
                    })
                    .orderBy(a => a.label)
                    .value()
            }
        },
        infosRotationCodeFamille() {
            if (this.etatStock && this.codeFamilleSelectionne) return this.etatStock.statsGlobalesFamilles[this.codeFamilleSelectionne].infoRotation
            return null
        },
        infosRotationsAllFamilles() {
            if (this.etatStock && this.etatStock.rotationsFamilles) {
                const nomsFamilles = Object.keys(this.etatStock.rotationsFamilles).filter(function(x): x is string {
                    return x !== undefined
                })
                return _.chain(nomsFamilles)
                    .map(nom => ({
                        label: nom,
                        data: this.etatStock?.rotationsFamilles[nom]
                    }))
                    .filter(function(x) {
                        return !!x.data
                    })
                    .orderBy(a => a.label)
                    .value()
            }
        },
        datesRotation(): any | null {
            return this.infosRotationsAllFamilles && this.infosRotationsAllFamilles.length ? { debut: this.infosRotationsAllFamilles[0].data?.dateDebut, fin: this.infosRotationsAllFamilles[0].data?.dateFin } : null
        },
        isAgent() : boolean {
            return this.$database.account.roleEnum == RoleEnum.Commercial
        }
    },
    mounted() {
        this.reload()
        this.alert.open()
    },
    methods: {
        onCompanyChange() {
            this.reload()
        },
        reload() {
            this.loadEtatStocks()?.then(() => this.generateChart())
        },
        generateChart() {
            if (!this.config) return
            if (this.chart) this.chart.destroy()

            const canvas = document.getElementById('ctx-chart')
            if (!canvas) return
            if (this.isMobileDevice() && this.codeFamilleSelectionne) {
                canvas.style.display = 'none'
            } else {
                canvas.style.display = 'block'
                const ctx = (canvas as HTMLCanvasElement).getContext('2d')
                if (!ctx) return

                // @ts-ignore
                this.chart = new Chart(ctx, this.config)
            }
        },
        deleteCodeFamilleSelectionne() {
            this.codeFamilleSelectionne = ''
            this.generateChart()
        },
        couleurRotationAnnuelleReelleProduit(rotation: EtatStockOutput_RotationStockProduit) {
            if (rotation.rotationAnnuelleReelle >= (rotation.rotationAnnuelleMini ?? 0)) return 'success'
            else if (rotation.rotationAnnuelleReelle === 0) return 'warning'
            else return 'error'
        },
        couleurRotationFinFamille(rotation: EtatStockOutput_RotationStockFamille) {
            if (rotation.quantiteFin < rotation.quantiteDebut) return 'blue lighten-1'
            if (rotation.quantiteFin > rotation.quantiteDebut && rotation.quantiteDebut !== 0) return 'yellow lighten-3'
            return ''
        },
        couleurRotationAnnuelleReelleFamille(rotation: EtatStockOutput_RotationStockFamille) {
            if (rotation.rotationAnnuelleReelle >= (rotation.rotationAnnuelleMini ?? 0)) return 'success'
            else if (rotation.quantiteDebut === 0) return 'warning'
            else return 'error'
        }
    }
})
